import React from 'react';
import type ProductsJsmOrganizationsList from '@atlassian/jira-products-jsm-organizations-list/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmOrganizations = lazyForPaint<typeof ProductsJsmOrganizationsList>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-products-jsm-organizations-list", jiraSpaEntry: "async-products-jsm-organizations-list" */ '@atlassian/jira-products-jsm-organizations-list/src/ui/index.tsx'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProductsJsmOrganizations}
		pageId="products-jsm-organizations-list"
		shouldShowSpinner
	/>
);
